import React from 'react';

const Button = ({btnRef, children, type = 'primary', size = 'md', className, elemType = 'button', ...rest}) => (
  <button ref={btnRef} className={`flex-btn btn btn-${size} btn-${type} ${className ? className : ''}`} type={elemType} {...rest}>
    {children}
  </button>
)

export default Button;